// LIBRARY
import React from "react";
import ProvinceTable from './table'
class ProvinceListComponent extends React.Component { 

	render(){
		return (
			<div>
				<ProvinceTable/>
			</div>
		);
	}
}

export default ProvinceListComponent;
  